import { render } from "./RangeFilter.vue?vue&type=template&id=5642a4c5&scoped=true"
import script from "./RangeFilter.vue?vue&type=script&lang=js"
export * from "./RangeFilter.vue?vue&type=script&lang=js"

import "./RangeFilter.vue?vue&type=style&index=0&id=5642a4c5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5642a4c5"]])

export default __exports__